import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
// internal imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PATHS } from "../../../../constants";
// action imports
import { updateTemplateSearchContent } from "../../../../actions/DocumentTemplateActions/templateActions";
// destructuring

class TemplateSearchDropdown extends Component {
  state = {};

  componentDidMount() {
    // add close event listner
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      event.target.dataset.id !== "template-search"
    ) {
      this.props.toggleDropdown(false);
    }
  };

  getSearchResults = () => {
    const {
      updateTemplateSearchContent: updateTemplateSearch,
      type,
      toggleSearchPage,
      toggleDropdown,
      searchTerm,
    } = this.props;
    let isGlobal = false;
    if (type === "global") {
      isGlobal = true;
    }
    if (searchTerm.trim()) {
      updateTemplateSearch(searchTerm, isGlobal, 0)
        .then(() => {
          toggleDropdown(false);
          toggleSearchPage(true);
        })
        .catch(() => {});
    }
  };

  _templateListItem = (item, index) => (
    <div
      className={`templateheader-search-dropdown-item ${
        this.props.pointer === index ? "activate-search-item-template" : null
      }`}>
      <FontAwesomeIcon
        icon={["fad", "file-alt"]}
        className="templateheader-search-file-icon file extquote-file-icon "
      />
      {item.title}
      <span className="templateheader-search-dropdown-item-by-label">
        created by
      </span>
      <span className="templateheader-search-dropdown-item-by">
        {item.created_by && item.created_by.name}
      </span>
    </div>
  );

  _getTemplateListItemWrapper = (item, index) => {
    const { type } = this.props;
    if (type === "global") {
      return (
        <div
          onClick={() => this.props.togglePreview(index)}
          tabIndex="0"
          role="button"
          onKeyDown={() => {}}>
          {this._templateListItem(item, index)}
        </div>
      );
    }
    return (
      <Link
        onClick={() => this.props.toggleDropdown(false)}
        key={`${item.id}-template-file-suggestion`}
        className="templateheader-search-dropdown-item-name"
        to={`${PATHS.DOCSTEMPLATE_PATH}/${item.id}`}>
        {this._templateListItem(item, index)}
      </Link>
    );
  };

  render() {
    const { showDropdown, searchTerm, templateSuggesstions } = this.props;
    let show = showDropdown;
    if (templateSuggesstions) {
      show = show && true;
    }
    return (
      <div
        ref={this.setWrapperRef}
        className={`templateheader-search-dropdown ${
          show ? "show-dropdown" : ""
        }`}>
        {/* Search for */}
        <div
          onClick={this.getSearchResults}
          tabIndex="0"
          role="button"
          onKeyDown={() => {}}
          className="templateheader-search-for">
          <FontAwesomeIcon
            icon={["far", "search"]}
            className="templateheader-search-for-icon"
          />
          Search for &quot;{searchTerm}&quot;
        </div>

        {/* Files List */}
        {templateSuggesstions &&
          templateSuggesstions.map((item, index) =>
            this._getTemplateListItemWrapper(item, index),
          )}
      </div>
    );
  }
}

TemplateSearchDropdown.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  updateTemplateSearchContent: PropTypes.func.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  showDropdown: PropTypes.bool.isRequired,
  togglePreview: PropTypes.func.isRequired,
};

const mapStateToProps = ({ TemplateStore: { templateSearchSuggestions } }) => ({
  templateSuggesstions: templateSearchSuggestions,
});

const mapDispatchToProps = {
  updateTemplateSearchContent,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemplateSearchDropdown);



// WEBPACK FOOTER //
// ./src/components/TemplateV2/TemplateHeader/TemplateHeaderSearch/TemplateSearchDropdown.js